import { ObjectWithAnyValues } from "utils/types";
import { BaseModel } from "../BaseModel";
import { CustomerDocumentType, CustomerFields, CustomerProps } from "./types";

export class Customer extends BaseModel {
	[CustomerFields.ID]: string;
	[CustomerFields.NAME]: string;
	[CustomerFields.DOCUMENT]: string;
	[CustomerFields.DOCUMENT_TYPE]?: CustomerDocumentType;
	[CustomerFields.EMAIL]: string;
	[CustomerFields.PHONE]: string;

	constructor(data: CustomerProps) {
		super(data);

		this[CustomerFields.ID] = data[CustomerFields.ID];
		this[CustomerFields.NAME] = data[CustomerFields.NAME];
		this[CustomerFields.DOCUMENT] = data[CustomerFields.DOCUMENT];
		this[CustomerFields.DOCUMENT_TYPE] = data?.[CustomerFields.DOCUMENT_TYPE];
		this[CustomerFields.EMAIL] = data[CustomerFields.EMAIL];
		this[CustomerFields.PHONE] = data[CustomerFields.PHONE];
	}

	static override createFromResponse(response: ObjectWithAnyValues) {
		if (!response) {
			return response;
		}

		const customer = new Customer({
			[CustomerFields.ID]: response[CustomerFields.ID],
			[CustomerFields.NAME]: response[CustomerFields.NAME],
			[CustomerFields.DOCUMENT]: response?.[CustomerFields.DOCUMENT],
			[CustomerFields.DOCUMENT_TYPE]: response?.[CustomerFields.DOCUMENT_TYPE],
			[CustomerFields.EMAIL]: response[CustomerFields.EMAIL],
			[CustomerFields.PHONE]: response[CustomerFields.PHONE]
		});
		return customer;
	}
}
